const containsEmojis = (text) => {
  const regex =
    /(?:\uD83C[\uDFFB-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD10-\uDDFF]|\uD83D[\uDE00-\uDE4F]|\uD83D[\uDE80-\uDEFF]|\uD83C[\uDDE6-\uDDFF])+/g;
  return text.match(regex)?.length > 0;
};

const checkTemplateName = (name) => {
  if (!name || name.trim() === "") {
    return "Template name is required";
  }
  return "";
};

const checkBody = (body) => {
  if (!body || body.trim() === "") {
    return "Body is required";
  }
  return "";
};

const checkQuickReply = (quickReply) => {
  if (!quickReply) {
    return "Button title is required";
  }
  if (quickReply && containsEmojis(quickReply)) {
    return "Emoji not allowed in button";
  }
  return "";
};

const checkUrlButton = (urlButton, urlButtonLink) => {
  if (urlButton && containsEmojis(urlButton)) {
    return "Emoji not allowed in button";
  }
  if (urlButton && !urlButtonLink) {
    return "Link is required";
  }
  return "";
};

const checkUrlButtonLink = (isLimitedTimeOffer, urlButtonLink, urlButton) => {
  if (isLimitedTimeOffer && !urlButtonLink) {
    return "Link is required";
  }
  if (!urlButton && urlButtonLink) {
    return "Title is required";
  }
  if (
    urlButtonLink &&
    (urlButtonLink.includes("{{1}}") ||
      urlButtonLink.includes("{{url_variable}}")) &&
    (!urlButtonLink.trim().endsWith("{{1}}") &&
      !urlButtonLink.trim().endsWith("{{url_variable}}"))
  ) {
    return "URL variable should be at the end of the URL";
  }
  return "";
};

const checkLimitedTimeOfferText = (limitedTimeOffer) => {
  if (!limitedTimeOffer || !limitedTimeOffer.text) {
    return "Offer text is required";
  }
  return "";
};

const checkCustomField = (saveAsCustomField, customField) => {
  if (saveAsCustomField && (!customField || customField === "")) {
    return "Please select a custom field";
  }
  return "";
};

const checkCardUrlButtonTitle = (text) => {
  if (!text || !text.trim()) return "Text is required";
  if (containsEmojis(text)) return "Emoji not allowed in button";
  return "";
};

const checkCardUrlButtonUrl = (url) => {
  if (!url || !url.trim()) return "Link is required";
  return "";
};

const checkCardQuickReplyText = (text) => {
  if (!text || !text.trim()) return "Title is required";
  if (containsEmojis(text)) return "Emoji not allowed in button";
  return "";
};

const checkCarousel = (cards) => {
  if (!cards || cards.length === 0) {
    return {
      hasError: true,
      bodyCardErrors: [],
      buttonCardErrors: [],
      generalError: "At least one card is required for carousel",
    };
  }

  const bodyCardErrors = [];
  const buttonCardErrors = [];
  let hasError = false;

  for (let cardIndex = 0; cardIndex < cards.length; cardIndex++) {
    const card = cards[cardIndex];
    const bodyComponent = card.components.find((c) => c.type === "BODY");
    const bodyText = bodyComponent?.text || "";

    const bodyError = checkBody(bodyText);
    if (bodyError) {
      bodyCardErrors[cardIndex] = bodyError;
      hasError = true;
    }

    const buttonsComponent = card.components.find((c) => c.type === "BUTTONS");
    if (buttonsComponent) {
      if (!buttonCardErrors[cardIndex]) buttonCardErrors[cardIndex] = {};
      for (
        let buttonIndex = 0;
        buttonIndex < buttonsComponent.buttons.length;
        buttonIndex++
      ) {
        const button = buttonsComponent.buttons[buttonIndex];
        if (!buttonCardErrors[cardIndex][buttonIndex])
          buttonCardErrors[cardIndex][buttonIndex] = {};

        if (button.type.toLowerCase() === "url") {
          const titleError = checkCardUrlButtonTitle(button.text);
          if (titleError) {
            buttonCardErrors[cardIndex][buttonIndex].title = titleError;
            hasError = true;
          }
          const urlError = checkCardUrlButtonUrl(button.url);
          if (urlError) {
            buttonCardErrors[cardIndex][buttonIndex].url = urlError;
            hasError = true;
          }
        } else if (button.type.toLowerCase() === "quick_reply") {
          const textError = checkCardQuickReplyText(button.text);
          if (textError) {
            buttonCardErrors[cardIndex][buttonIndex].text = textError;
            hasError = true;
          }
        }
      }
    }
  }

  return { hasError, bodyCardErrors, buttonCardErrors };
};

const formChecks = {
  checkTemplateName,
  checkBody,
  checkQuickReply,
  checkUrlButton,
  checkUrlButtonLink,
  checkLimitedTimeOfferText,
  checkCustomField,
  checkCardUrlButtonTitle,
  checkCardUrlButtonUrl,
  checkCardQuickReplyText,
  checkCarousel,
};

export default formChecks;
